import React, { FC } from 'react';
import ScrapePoolList from './ScrapePoolList';

const Targets: FC = () => {
  return (
    <>
      <h2>Targets</h2>
      <ScrapePoolList />
    </>
  );
};

export default Targets;
